<template>
    <span   v-if="types===1" class="btn dark-bg" >{{value}}</span>
    <span   v-else-if="types===2"  class="btn no-bg">{{value}}</span>
    <span   v-else class="btn" :class="isWidth ? 'hasWidth' : ''">{{value}}</span>

</template>
  
  <script>
  export default {
    props: {
      value:{
        type:String,
        default:"btn样式"
      },
      types: {
        type: Number,
        default:null
      },
      isWidth:{
        type: Boolean,
        default:false
      }
    },
    components: {
     
    },
    methods:{
      // getValue(){
      //   this.$emit("updateValue",props.value); 
      // }
    }
  };
  </script>
  
  <style lang="scss">
    .btn{
      display: inline-block;
        height: 24px;
        line-height: 24px;
        font-size: 12px;
        border-radius: 12px;
        background: #EBEEFF;
        padding: 0 10px;
        font-family: PingFangSC-Regular, PingFang SC;
        font-weight: 400;
        color: rgba(0,0,0,0.5);
        margin-right: 20px;
        margin-bottom: 10px;
        
    }
    .dark-bg{
      background:rgba(40, 124, 243, .3)
    }
    .no-bg{
      height: 24px;
      background-color: #fff;
      border: 1px solid #287CF3;
      color: #287CF3;
    }
    .hasWidth{
        max-width: 90px;
        overflow: hidden;
        text-overflow: ellipsis;
        white-space: nowrap;
    }
  
  </style>
  